<template>
  <tr>
    <td class="has-Checkbox">
      <input type="checkbox" :value="item.id" @change="onChange" :checked="isChecked" :id="`sel${index + 1}`" />
    </td>
    <td>
      <label class="postsTable__ItemTitle" :for="`sel${index + 1}`">{{ item.full_name }}</label>
      <ul class="postsTable__ItemActions">
        <li>
          <router-link :to="{ name: 'Edit organisation', params: { id: item.id } }" append>Edit</router-link>
        </li>
        <li>
          <button @click="disable('org')">{{ disableLabel }}</button>
        </li>
      </ul>
    </td>
    <td>
      <span>{{ item.statistics.user_count }}</span>
    </td>
    <td>
      <span>{{ moment(item.inserted_at).format('DD.MM.YYYY.') }}</span>
    </td>
    <td>
      <span>{{ moment(item.updated_at).format('DD.MM.YYYY.') }}</span>
    </td>
  </tr>
</template>

<script>
import EventBus from '@/bus.js'

import IsChecked from '@/components/mixins/IsChecked.js'
import DisableItem from '@/components/mixins/DisableItem.js'
import GetProperty from '@/components/mixins/GetProperty.js'
import GetTagByType from '@/components/mixins/GetTagByType.js'

export default {
  props: ['item', 'index', 'selected', 'orgs'],
  mixins: [IsChecked, DisableItem, GetProperty, GetTagByType],
  name: 'Organisation',
  data() {
    return {
      status: this.item.status,
    }
  },
  computed: {
    tags() {
      return this.$store.state.tags.list
    },
    lang() {
      return this.$store.state.ui.lang
    },
  },
  created() {
    EventBus.$on('actionDisable', (ids) => {
      ids = JSON.parse(ids)
      if (ids.includes(this.item.id)) {
        this.disabler('org')
      }
    })
  },
}
</script>
